







































import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import { Select, Input } from "ant-design-vue";
import CModal from "@/components/CModal/index.vue";

@Component({
  name: "SigleEdit",
  components: {
    CModal,
    AInput: Input,
    AInputPassword: Input.Password,
    ASelect: Select,
    ASelectOption: Select.Option
  }
})
export default class SigleEdit extends Base {
  private init = false;
  private visible = false;
  private ssoConfigList: any[] = [];
  private currentIdx = -1;
  private systemName = "";
  private systemNameCn = "";
  private userName = "";
  private password = "";

  private created() {
    this.getSsoConfigList();
  }

  /**
   * @param {object} data 编辑数据
   * @param {boolean} show 指定visible的布尔值
   */
  private changeVisible(data: any, show: boolean) {
    if (data && Object.keys(data).length) {
      this.systemName = data.systemName;
      this.systemNameCn = data.systemNameCn;
      this.userName = data.userName;
      this.password = data.password;
    }

    this.setDefaultCurrentIdx();

    if (show === void 0) {
      this.visible = !this.visible;
    } else {
      this.visible = show;
    }
  }

  private setDefaultCurrentIdx() {
    if (this.systemName && this.ssoConfigList.length) {
      this.ssoConfigList.find((item: any, idx: number) => {
        if (item.systemName === this.systemName) {
          this.currentIdx = idx;
          return;
        }
      });
    }
  }

  private onSelect(value: string, option: any) {
    this.currentIdx = option.data.key;
  }

  private async getSsoConfigList() {
    const res = await this.$api.SsoConfigList();
    if (res && res.code === 200) {
      this.ssoConfigList = res.rows;
    }
  }

  private beforeSave() {
    let msg = "";
    if (this.currentIdx < 0) {
      msg = "请选择登录系统";
    }

    if (!this.userName && msg === "") {
      msg = "请填写用户名";
    }

    if (!this.password && msg === "") {
      msg = "请填写密码";
    }

    if (msg) {
      this.$message.destroy();
      this.$message.error(msg);
      return false;
    } else {
      return true;
    }
  }

  private async save() {
    if (!this.beforeSave()) {
      return;
    }

    const res = await this.$api.SsoInfoAdd(this.reqParams);
    if (res && res.code === 200) {
      this.visible = false;
      this.$message.destroy();
      this.$message.success("保存成功");
      this.$emit("success");
      this.clearData();
    }
  }

  private clearData() {
    this.currentIdx = -1;
    this.systemName = "";
    this.systemNameCn = "";
    this.userName = "";
    this.password = "";
  }

  private get reqParams() {
    const _return = {
      systemName: this.ssoConfigList[this.currentIdx].systemName,
      systemNameCn: this.ssoConfigList[this.currentIdx].systemNameCn,
      userName: this.userName,
      password: this.password
    };
    return _return;
  }
}
